import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { Button } from "../../components/ui/button";
import { AlertTriangle, Database, ChevronRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BackupHealthBanner = ({ token, onNavigate }) => {
  const [health, setHealth] = useState(null);

  const fetchHealth = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/admin/backup/health`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setHealth(res.data);
    } catch {
      setHealth(null);
    }
  }, [token]);

  useEffect(() => { fetchHealth(); }, [fetchHealth]);

  // Nessun problema → non mostrare nulla
  if (!health || health.ok) return null;

  const failed = health.failed || [];
  const stale = health.stale || [];
  const nomiFalliti = [...new Set(failed.map((f) => f.societa_nome).filter(Boolean))];
  const nomiStale = stale.map((s) => s.societa_nome).filter(Boolean);

  return (
    <div
      className="rounded-2xl border border-amber-300 bg-amber-50 p-5 shadow-sm"
      data-testid="backup-health-banner"
    >
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-xl bg-amber-100 flex items-center justify-center shrink-0">
          <AlertTriangle className="h-5 w-5 text-amber-600" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-bold text-amber-900 text-sm">Attenzione backup</p>

          {failed.length > 0 && (
            <p className="text-sm text-amber-800 mt-1" data-testid="backup-health-failed">
              <strong>{failed.length}</strong> backup falliti nell'ultima notte
              {nomiFalliti.length > 0 && (
                <span className="text-amber-700">
                  {" "}— {nomiFalliti.slice(0, 4).join(", ")}
                  {nomiFalliti.length > 4 ? ` +${nomiFalliti.length - 4}` : ""}
                </span>
              )}
              .
            </p>
          )}

          {stale.length > 0 && (
            <p className="text-sm text-amber-800 mt-1" data-testid="backup-health-stale">
              <strong>{stale.length}</strong> società senza backup da oltre 48h
              {nomiStale.length > 0 && (
                <span className="text-amber-700">
                  {" "}— {nomiStale.slice(0, 4).join(", ")}
                  {nomiStale.length > 4 ? ` +${nomiStale.length - 4}` : ""}
                </span>
              )}
              .
            </p>
          )}

          <p className="text-xs text-amber-600 mt-2">
            Controlla il pannello Backup e, se necessario, esegui un backup manuale.
          </p>
        </div>
        <Button
          size="sm"
          variant="outline"
          onClick={() => onNavigate && onNavigate("backup")}
          className="rounded-xl text-xs border-amber-300 text-amber-800 hover:bg-amber-100 shrink-0"
          data-testid="backup-health-goto-btn"
        >
          <Database className="h-3.5 w-3.5 mr-1.5" />
          Apri Backup
          <ChevronRight className="h-3.5 w-3.5 ml-0.5" />
        </Button>
      </div>
    </div>
  );
};

export default BackupHealthBanner;
